// Lock-screen / notification controls (Media Session API).
// Tells the phone this page is a music player: the song shows on the lock screen
// with play, pause and skip, and Android treats playback more like a music app.

const supported = () => typeof navigator !== 'undefined' && 'mediaSession' in navigator

export function setNowPlaying ({ title, artist, station }) {
  if (!supported() || typeof window.MediaMetadata === 'undefined') return
  try {
    navigator.mediaSession.metadata = new window.MediaMetadata({
      title: title || 'GymRadio.com',
      artist: artist || '',
      album: station ? `GymRadio.com · ${station}` : 'GymRadio.com',
      artwork: [{ src: '/assets/favicons/android-chrome-512x512.png', sizes: '512x512', type: 'image/png' }]
    })
  } catch (e) {}
}

export function setPlaybackState (playing) {
  if (!supported()) return
  try { navigator.mediaSession.playbackState = playing ? 'playing' : 'paused' } catch (e) {}
}

export function setHandlers ({ onPlay, onPause, onNext }) {
  if (!supported()) return
  const set = (action, fn) => {
    try { navigator.mediaSession.setActionHandler(action, fn) } catch (e) {}
  }
  set('play', onPlay)
  set('pause', onPause)
  set('nexttrack', onNext)
  // No going back or seeking within a radio stream
  set('previoustrack', null)
  set('seekbackward', null)
  set('seekforward', null)
  set('seekto', null)
}
